import { darken } from '@mui/material';

export class ColorGenerator {
    private colorMap: Record<string, string> = {};
    private colorLevelMap: Record<string, number> = {};

    constructor(private baseColors: string[]) {
        if (baseColors.length === 0) {
            throw new Error('There are no base colors');
        }
    }

    getColorByLevel = (color: string, level: number) => {
        let newColor = color;

        while (level > 0) {
            newColor = darken(color, 0.2);
            level--;
        }

        return newColor;
    };

    getNextColor = (scope?: string | number, reset = false) => {
        const key = String(scope);

        if (reset || !Object.prototype.hasOwnProperty.call(this.colorLevelMap, key)) {
            this.colorLevelMap[key] = 0;
        } else {
            this.colorLevelMap[key]!++;
        }

        const color = this.baseColors[this.colorLevelMap[key]! % this.baseColors.length]!;
        const level = Math.floor(this.colorLevelMap[key]! / this.baseColors.length);

        return this.getColorByLevel(color, level);
    };

    getColorByKey = (key: string | number, scope = '') => {
        const keyWithScope = `${key}:${scope}`;
        if (!Object.prototype.hasOwnProperty.call(this.colorMap, keyWithScope)) {
            this.colorMap[keyWithScope] = this.getNextColor(scope);
        }

        return this.colorMap[keyWithScope]!;
    };
}

export const defaultColorGenerator = new ColorGenerator([
    '#f44336',
    '#e91e63',
    '#9c27b0',
    '#673ab7',
    '#3f51b5',
    '#2196f3',
    '#03a9f4',
    '#00bcd4',
    '#009688',
    '#4caf50',
    '#8bc34a',
    '#cddc39',
    '#ffeb3b',
    '#ffc107',
    '#ff9800',
    '#ff5722',
    '#795548',
    '#9e9e9e',
    '#607d8b',
]);
